<i18n src="@/locales/modules/RequestTypeTranslate.json"></i18n>

<template>
	<div class="request-type-config">
		<div class="header request-type-config__header flex justify-between mb-10 flex-wrap">
			<div class="header__navigation flex items-center">
				<i class="nucleo nucleo-arrow-left text-black text-3xl mr-6 sm:mr-12 cursor-pointer" @click.once="$router.go(-1)"></i>
				<h2>{{ $t("Report") }}</h2>
			</div>
			<div class="flex justify-between">
				<CbsDatePicker class="mr-2" v-model="month" type="month" placeholder="Chọn tháng" :picker-options="pickerOptions" />
				<cbs-download-button class="mr-3" :btnText="$t('Actions.DownloadReport')" @click.stop="handleDownloadReport" />
			</div>
		</div>
		<vs-tabs v-if="reports && reports.length > 0">
			<vs-tab v-for="(report, index) in reports" :key="`reportTab${index}`" :label="report.name">
				<div class="">
					<iframe class="w-full h-screen debt-report-container border-none" allowfullscreen="true" :src="report.display"></iframe>
				</div>
			</vs-tab>
		</vs-tabs>
	</div>
</template>

<script>
import moduleCustomer from "@/store/customer/moduleCustomer";
import customerGql from "@/http/requests/card/customer_gql";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
import moment from "moment";
export default {
	name: "CustomerDebtReporting",
	components: { CbsDatePicker },
	computed: {
		reports() {
			const t = this.$store.state.customerManagement && this.$store.state.customerManagement.debtsReportExcel ? this.$store.state.customerManagement.debtsReportExcel : [];
			return t;
		}
	},
	data() {
		return {
			month: "",
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				}
			}
		};
	},
	watch: {
		month() {
			console.log("month", moment(this.month).month());
			this.handleExportReport();
		}
	},
	methods: {
		async handleExportReport() {
			try {
				let payload = {};
				if (this.month !== "") {
					payload = { to_month: moment(this.month).month() + 1, to_year: moment(this.month).year() };
				}
				this.$vs.loading();
				await this.$store.dispatch("customerManagement/exportCustomerData", payload);
				this.$router.history.push({
					name: this.$constant.PAGES_NAME.PAGE_CBS_CUSTOMER_DEBPT_REPORTING
				});
			} catch (error) {
				console.error("handleExportReport", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleDownloadReport() {
			try {
				this.$vs.loading();
				const response = await customerGql.downloadCustomerDebtsFile();
				const fileName = response.split("/");
				await this.handleDownloadFile({
					path: response,
					file_name: fileName[fileName.length - 1]
				});
			} catch (error) {
				console.error("handleDownloadReport", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		}
	},
	async created() {
		await this.$store.registerModule("customerManagement", moduleCustomer);
		this.handleExportReport();
	},
	beforeDestroy() {
		this.$store.unregisterModule("customerManagement");
	}
};
</script>

<style lang="scss">
.request-type-config {
	top: -52px;
	position: relative;
	background-color: #fff;

	::v-deep .parent-form--empty {
		.footer {
			margin-top: -15px !important;
		}
	}
}
</style>
